// extracted by mini-css-extract-plugin
export var label = "_im-2";
export var slideContainer = "_im-0";
export var slider = "_im-1";